import { default as ReactSelect, GroupBase, Props } from 'react-select';

export function Select<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: Props<Option, IsMulti, Group>) {
  return <ReactSelect {...props} theme={(theme) => ({ ...theme })} />;
}
